// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_kcp","questions":"styles_questions__2BZHf","footer":"styles_footer__5YFs2"};